import React from "react";
import { Divider, Typography } from "@mui/material";
import "react-medium-image-zoom/dist/styles.css";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Zoom from "react-medium-image-zoom";
import "../JaldiLab.css";
import BorderImage from "../../../assets/SvgIcons/Frame 1000006365 (1).svg";

export const paraStyle = {
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "26px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "15px 0px",
};

export const squareListStyle = {
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "26px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "8px 0px",
};

export const orderListStyle = {
  fontFamily: "Lato",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "26px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "15px 0px",
};

export const sectionStyle = {
  cursor: "pointer",
  color: "#DC002D",
};
export const authorStyle = {
  color: "#DC002D",
  fontSize: "17px",
};

export const tableCellStyle = {
  fontWeight: 400,
  fontSize: "14px",
  color: "#555555",
  verticalAlign: "baseline",
  lineHeight: "23px",
};

export const customHeading4 = {
  color: "#1D1D1D",
  fontFamily: "GT Super Text",
  fontWeight: "700",
  textAlign: "left",
  fontStyle: "italic",
  cursor: "pointer",
  margin: "20px 5px 20px 30px",
  fontSize: "22px",
  lineHeight: "33px",
};

export const tableHeader = {
  color: "#000",
  fontWeight: 600,
};

export const tableParagraph = {
  fontSize: "15px",
  fontWeight: 400,
  color: "rgb(85, 85, 85)",
  lineHeight: '1.8'
};

export const tableHeading = {
  color: "#000",
  fontSize: "1rem",
  fontWeight: 600,
  paddingRight: "5px",
};

export const tableCaption = {
  fontFamily: "Lato",
  fontSize: "16px",
  fontStyle: "italic",
  fontWeight: "500",
  lineHeight: "26px",
  textAlign: "left",
};

export const DividerBorderStyle = () => {
  return (
    <Divider
      style={{
        margin: "30px 0px 30px 0px",
        border: "1px solid lightGray",
      }}
    />
  );
};

export const DashedBorderStyle = () => {
  return (
    <img
      src={BorderImage}
      alt="Border  Image"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        marginTop: "30px",
        marginBottom: "15px",
      }}
    />
  );
};

export const pointStyle = {
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "27px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "7px 30px",
};

export const pointStyleOrderListItem = {
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "27px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "7px 55px",
};

export const orderListHeading = {
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "27px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "0px !important",
};

export const pointStyle1 = {
  fontFamily: "Lato",
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "27px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "7px 30px",
};

export const dimensionStyle = {
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "700",
  fontStyle: "italic",
  lineHeight: "27px",
  color: "#FF8278",
};

export const subHeadingOrderListStyle = {
  fontFamily: "Lato",
  fontSize: "18px",
  fontWeight: "400",
  lineHeight: "27px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "7px 40px",
};

export const captionStyle = {
  maxWidth: "910px",
  padding: "0 10px",
  lineHeight: "27px",
  textAlign: "center",
  fontFamily: "lato",
  fontSize: "18px",
  fontWeight: 500,
  fontStyle: "italic",
  color: "#1D1D1D",
};

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement="top" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    borderRadius: "10px",
  },
}));

export const referenceHtml = (stringsArray) => {
  return (
    <ol style={{ paddingInlineStart: "0px" }}>
      {stringsArray?.map((text, index) => (
        <li style={{ ...pointStyle }} key={text.content}>
          {text.content}
          {text?.link && (
            <a
              style={{
                color: "#DC002D",
                textDecoration: "none",
              }}
              href={text.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {text.description}
            </a>
          )}
        </li>
      ))}
    </ol>
  );
};

export function referenceTootKit(
  _data,
  number,
  handleScrollToReferences,
  isColor = false
) {
  return (
    <HtmlTooltip
      title={
        <p>
          {_data.content}
          {_data?.link && (
            <a
              style={{
                color: "#DC002D",
                textDecoration: "none",
              }}
              href={_data.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {_data.description}
            </a>
          )}
        </p>
      }
    >
      <span
        style={{
          color: isColor ? "#fff" : "#DC002D",
          cursor: "pointer",
        }}
        onClick={handleScrollToReferences}
      >
        ({number})
      </span>
    </HtmlTooltip>
  );
}

const tableItemStyle = {
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "400",
  lineHeight: "27px",
  color: "#555555",
  letterSpacing: "0em",
  textAlign: "justified",
  margin: "10px 20px",
};

export const generateTableOrderedList = (stringsArray) => {
  return (
    <>
      {stringsArray?.map((text, index) => (
        <p style={tableItemStyle}>{text}</p>
      ))}
    </>
  );
};

export const generateTableUnOrderedList = (stringsArray) => {
  return (
    <p id="typgraphyList">
      {stringsArray?.map((text, index) => (
        <p style={tableItemStyle}>{text}</p>
      ))}
    </p>
  );
};

export const subHeadingContent = (data) => {
  let counter = 1;
  return (
    <div>
      {data.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          <div className="sub-heading-h4"
            style={{ display: "flex", paddingTop: "10px" }}>
            {section.icon}
            <h4
              style={{
                ...h4style,
                margin: "8px 5px",
                fontSize: "22px",
                lineHeight: "33px",
              }}
            >
              <i>{section.heading}</i>
            </h4>
          </div>

          {section?.items?.map((item, itemIndex) => {
            return (
              <p style={subHeadingOrderListStyle} key={itemIndex}>{counter++}. {item}</p>
            )
          })}
        </div>
      ))}
    </div>
  )
}

export const generateUnOrderedList = (stringsArray, fontSize) => {
  return (
    <Typography id="typgraphyList">
      {stringsArray?.map((text, index) => (
        <p style={fontSize ? pointStyle1 : pointStyle}>{text}</p>
      ))}
    </Typography>
  );
};

export const generateUnOrderedListWithImg = (stringsArray) => {
  return (
    <>
      {stringsArray?.map((item, index) => (
        <>
          {item.text && (
            <Typography id="typgraphyList">
              <p style={pointStyle}>{item.text}</p>
            </Typography>
          )}
          {item?.tableData && item.tableData}
          {item?.imageSection && item.imageSection}
          {item?.captionSource && (
            <p>
              <b>Source: </b>
              {item?.captionSource}
            </p>
          )}
        </>
      ))}
    </>

  );
};

export const generateOrderedListWithImg = (stringsArray) => {
  return (
    <>
      <Typography>
        <ol style={{ paddingInlineStart: "0px" }}>
          {stringsArray?.map((item, index) => (
            <>

              {item.text && (
                <li style={{ ...pointStyle }} key={index}>
                  {item.text}
                </li>
              )}
              {item?.tableData && item.tableData}
              {item?.imageSection && item.imageSection}
              {item?.captionSource && (
                <p>
                  <b>Source: </b>
                  {item?.captionSource}
                </p>
              )}
            </>

          ))}
        </ol>
      </Typography >
    </>
  );
};

export const generateParagraphsWithHeading = (stringsArray) => {
  return (
    <Typography id="typgraphyList">
      {stringsArray?.map((text, index) => (
        <p style={pointStyle}>
          <h3 style={{ color: "black" }}>{text?.heading}</h3>
          {text?.content}
        </p>
      ))}
    </Typography>
  );
};

export const generateOrderedList = (_stringsArray) => {
  return (
    <Typography>
      <ol style={{ paddingInlineStart: "0px" }}>
        {_stringsArray?.map((text, index) => (
          <li style={{ ...pointStyle }} key={index}>
            {text}
          </li>
        ))}
      </ol>
    </Typography>
  );
};
export const generateOrderedListDialogBox = (_stringsArray) => {
  return (
    <Typography>
      <ol style={{ paddingInlineStart: "0px" }}>
        {_stringsArray?.map((text, index) => (
          <li style={{
            color: "#1D1D1D",
            fontFamily: "Lato",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "22px",
            letterSpacing: "0em",
            textAlign: "justified",
            margin: "10px 30px",
          }}
            key={index}>
            {text}
          </li>
        ))}
      </ol>
    </Typography>
  );
};

export const itemOrderedList = (_stringsArray) => {
  return (
    <Typography>
      <ol style={{ paddingInlineStart: "0px" }}>
        {_stringsArray?.map((text, index) => (
          <li style={pointStyleOrderListItem} key={index}>
            {text}
          </li>
        ))}
      </ol>
    </Typography>
  );
};

export const generateOrderedListNew = (_stringsArray) => {
  return (
    <Typography>
      <ol style={{ paddingInlineStart: "0px" }}>
        {_stringsArray?.map((text, index) => (
          <li style={{ ...pointStyle }} key={index}>
            {text}
          </li>
        ))}
      </ol>
    </Typography>
  );
};

export const orderedListWithItem = (_stringsArray) => {
  return (
    <ol className="custom-list">
      {_stringsArray?.map((text, index) => (
        <li key={`item-${index}`}>
          <span style={{ fontWeight: "bold", padding: "100px 0px !important" }}>{text.item}</span>
          <ol type="a">
            {
              text?.subData?.map((elem) => (
                <li>{elem.subItem}</li>
              ))
            }
          </ol>
        </li>
      ))}
    </ol>
  );
};

export const generateCustomOrderedListObj = (_stringsArray, type) => {
  return (
    <Typography>
      <ol type={type}>
        {_stringsArray?.map((arr, index) => (
          <>
            <li style={{ ...pointStyle, paddingLeft: "10px" }} key={index}>
              {arr.content}
              {arr.img}
              {arr.para}
            </li>
          </>
        ))}
      </ol>
    </Typography>
  );
};

export const getTextNestedList = (_data) => {
  return (
    <ol className="custom-list">
      {_data && _data.map((elem, index) => (
        <li key={`item-${index}`}>
          <span style={{ fontWeight: "bold", padding: "100px 0px !important" }}>{elem?.item}</span>
          <ol className="nested-list">
            {elem?.subData?.map((ele, subIndex) => (
              <li key={`subItem-${index}-${subIndex}`}>
                {ele?.subItem}
                <ol className="nested-list-item">
                  {ele?.nestedItem?.map((item, nestedIndex) => (
                    <li key={`nestedItem-${index}-${subIndex}-${nestedIndex}`}>
                      {item}
                    </li>
                  ))}
                </ol>
              </li>
            ))}
          </ol>
        </li>
      ))}
    </ol>
  );
};


export const getTextContentWithHeading = (_data) => {
  return (
    <>
      <div style={{ display: "flex", paddingTop: "10px" }}>
        {_data.icon}
        {_data.heading && (
          <h4
            style={{
              ...h4style,
              margin: "8px 5px",
              fontSize: "22px",
              lineHeight: "33px",
            }}
          >
            <i>{_data.heading}</i>
          </h4>
        )}
      </div>
      {_data?.isOrdered
        ? generateOrderedList(_data.data)
        : generateUnOrderedList(_data.data)}
    </>
  );
};

export const getTextContentHeading = (_data, fontSize) => {
  return (
    <>
      <div style={{ display: "flex", paddingTop: "10px" }}>
        {_data.icon}
        {_data.heading && (
          <h4
            style={{
              ...h4style,
              margin: "8px 5px",
              fontSize: "22px",
              lineHeight: "33px",
            }}
          >
            <i>{_data.heading}</i>
          </h4>
        )}
      </div>
      {_data?.isImage
        ? itemOrderedList(_data.data)
        : generateUnOrderedList(_data.data, fontSize)}
    </>
  );
};

export const getHeadingContent = (_data) => {
  return (
    <>
      <div style={{ display: "flex", paddingTop: "10px" }}>
        {_data.icon}
        {_data.heading && (
          <h4
            style={{
              ...h4style,
              margin: "8px 5px",
              fontSize: "22px",
              lineHeight: "33px",
            }}
          >
            <i>{_data.heading}</i>
          </h4>
        )}
      </div>
      {generateOrderedList(_data.data)}
    </>
  );
};

export const getTextContentHeadingImg = (_data) => {
  return (
    <>
      <div style={{ display: "flex", paddingTop: "10px" }}>
        {_data.icon}
        <h4 style={h4style}>
          <i>{_data.heading}</i>
        </h4>
      </div>
      {(_data?.isImage && _data?.isOrdered) ? generateOrderedListWithImg(_data.data) : generateUnOrderedListWithImg(_data.data)}
    </>
  );
};

export const getCircleListItem = (_stringsArray) => {
  return (
    <ul>
      {_stringsArray?.map((arr, index) => (
        <>
          <li style={{ ...pointStyle, paddingLeft: "10px" }} key={index}>
            {arr.content}
          </li>
          {arr.img}
        </>
      ))}
    </ul>
  );
};

export const getSquareTypeListItem = (_data) => {
  return (
    <ul style={{ listStyleType: "square" }}>
      {_data &&
        _data.map((elem) => {
          return <li style={squareListStyle}>{elem}</li>;
        })}
    </ul>
  )
}

export const getCircleTypeListItem = (
  _data,
  isCircle = true,
  type,
  isBold = false
) => {
  return (
    <>
      {isCircle ? (
        <ul className={isCircle && "listTypeCircle"}>
          {_data &&
            _data?.map((elem) => {
              return <li style={squareListStyle}>{elem}</li>;
            })}
        </ul>
      ) : isBold ? (
        <ol style={paraStyle} type={type}>
          {_data &&
            _data?.map((elem) => {
              const data = elem.split("-")[0];
              const data1 = elem.split("-")[1];
              return (
                <li>
                  <b>{data}</b>-{data1}
                </li>
              );
            })}
        </ol>
      ) : (
        <ol style={paraStyle} type={type}>
          {_data &&
            _data.map((elem) => {
              return <li style={{padding:"4px 0px"}}>{elem}</li>;
            })}
        </ol>
      )}
    </>
  );
};

export const getCircleTypeListItemCustom = (_data, isCircle = true, type) => {
  return (
    <>
      <ol style={orderListStyle} type={type}>
        {_data &&
          _data.map((elem) => {
            return <li>{elem}</li>;
          })}
      </ol>
    </>
  );
};

export const h1style = {
  color: "#FF8278",
  fontFamily: "GT Super Text",
  fontSize: " 32px",
  fontWeight: "700",
  lineHeight: "37px",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "none",
  cursor: "pointer",
  margin: "20px 0px",
};

export const h2style = {
  color: "#1D1D1D",
  fontFamily: "GT Super Text",
  fontSize: " 28px",
  fontWeight: "700",
  lineHeight: "36px",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "none",
  cursor: "pointer",
  margin: "30px 0px 24px 0",
  paddingLeft: "16px",
};

export const h3style = {
  color: "#DC002D",
  fontFamily: "GT Super Text",
  fontSize: "24px",
  fontWeight: "700",
  // lineHeight: "42px",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "none",
  cursor: "pointer",
  margin: "16px 0",
};
export const referenceStyle = {
  color: "black",
  fontFamily: "GT Super Text",
  fontSize: " 24px",
  fontWeight: "700",
  // lineHeight: "42px",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "italic",
  cursor: "pointer",
  margin: "35px 0px 10px 0px",
};

export const h4style = {
  color: "#1D1D1D",
  fontFamily: "GT Super Text",
  fontSize: " 24px",
  fontWeight: "700",
  lineHeight: "36px",
  height: "36px",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "none",
  cursor: "pointer",
  margin: "8px 0px",
};

export const subHeadingStyle = {
  color: " #1D1D1D",
  fontFamily: "GT Super Text",
  fontSize: "22px",
  fontWeight: "700",
  lineHeight: "33px",
  letterSpacing: "0px",
  textAlign: "left",
  fontStyle: "italic",
  padding: "0px 0px 0px 30px",
  textDecoration: "underline",
};

export const textDecorationStyle = {
  textDecoration: "underline",
};

export const captionWithBorders = (
  image,
  isZoom,
  caption,
  imageCredit = "",
  height = "auto"
) => {
  return (
    <div style={{ padding: "15px 10px" }}>
      {isZoom ? (
        <Zoom>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: height && height,
              padding: "20px 0px",
            }}
          >
            {
              <img
                src={image}
                alt="zoom_img"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            }
          </div>
        </Zoom>
      ) : (
        image && (
          <div
            style={{
              minWidth: "300px",
              maxWidth: "650px",
              height: height || "auto",
              margin: "0 auto",
            }}
          >
            <img
              src={image}
              alt="chapter_img"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </div>
        )
      )}
      {caption && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: "15px",
          }}
        >
          <Divider style={{ flexGrow: 1, borderBottom: "1px solid red" }} />
          <div style={{ textAlign: "center" }}>
            <Typography style={captionStyle}>{caption}</Typography>
            {imageCredit && (
              <span
                style={{
                  fontFamily: "lato",
                  fontWeight: 500,
                  fontStyle: "italic",
                  fontSize: "12px",
                  color: "#1D1D1D",
                }}
              >
                Image Credit:{" "}
                <span
                  style={{
                    fontFamily: "lato",
                    fontWeight: 500,
                    fontStyle: "italic",
                    color: "red",
                  }}
                >
                  {imageCredit}
                </span>
              </span>
            )}
          </div>
          <Divider style={{ flexGrow: 1, borderBottom: "1px solid red" }} />
        </div>
      )}
    </div>
  );
};
